import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=269d62a4&scoped=true"
import script from "./MenuDetail.vue?vue&type=script&lang=js"
export * from "./MenuDetail.vue?vue&type=script&lang=js"
import style0 from "./MenuDetail.vue?vue&type=style&index=0&id=269d62a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269d62a4",
  null
  
)

export default component.exports